export const conf = {
    server: "https://xm3dview.com",
 }
 
